import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useLoginPopup } from 'features/account';
import { useAuth } from 'providers/AuthProvider';
import { authService } from 'services/auth/authService';
import { getAuthToken, getAuthType } from 'utils/localStorageData';

import { isTechnicalUserAllowedPath } from './technicalUserAccess';

export const TechnicalUserGuard = () => {
  const location = useLocation();
  const { logged, appLogout } = useAuth();
  const { showLoginPopup } = useLoginPopup();
  const isLoggingOut = useRef(false);

  useEffect(() => {
    if (!logged || getAuthType() !== 'Technical' || isTechnicalUserAllowedPath(location.pathname)) {
      return;
    }

    if (isLoggingOut.current) {
      return;
    }

    isLoggingOut.current = true;

    const logoutTechnicalUser = async () => {
      const authToken = getAuthToken();

      if (authToken) {
        await authService.logout(authToken).catch(() => undefined);
      }

      appLogout();
      showLoginPopup();
      isLoggingOut.current = false;
    };

    logoutTechnicalUser();
  }, [location.pathname, logged, appLogout, showLoginPopup]);

  return null;
};
